import type { ReactNode } from 'react';
import { ConfirmProvider } from './ConfirmDialog';
import { ShortcutsProvider } from './hotkeys';
import { ShortcutsDialog } from './ShortcutsDialog';
import { Toaster } from './toast';
import { TooltipProvider } from './Tooltip';

/** Everything the kit needs once per app: tooltips, shortcuts (and the `?` sheet), confirmations, toasts. */
export function UiProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={300}>
      <ShortcutsProvider>
        <ConfirmProvider>
          {children}
          <ShortcutsDialog />
          <Toaster />
        </ConfirmProvider>
      </ShortcutsProvider>
    </TooltipProvider>
  );
}
